export default {

	async modal_opening_hours (company_db_id, storage_id) {

		const [ company_db, storage ] = await Promise.all([
			Anvil.models.c_order.CompanyDB.fetch(company_db_id),
			Anvil.models.c_order.Storage.fetch(company_db_id, storage_id)
		])

		const auth = Anvil.models.c_store.Util.encodeApiKey(company_db.db_name, company_db.webapi_authcode)
		const cStore = new Anvil.models.rest.Client('ugyfel.c-store.eu', 443, auth)

		const res = await cStore.post('/api/v4/c-order/pull_site_opening_hours', {
			db_name: company_db.db_name,
			site_id: storage.site_id,
			store_id: storage.id
		})

		const opening_hours = new Anvil.models.c_order.OpeningHours((res.success === true) ? res.opening_hours : {
			regular_days: null,
			irregular_days: []
		})

		await Anvil.modal('/c_order/storage/modal_opening_hours', { storage, opening_hours })
	},

	async action_save_opening_hours (storage, opening_hours) {

		// Save the opening hours
		const company_db = await Anvil.models.c_order.CompanyDB.fetch(storage.company_db_id)

		const auth = Anvil.models.c_store.Util.encodeApiKey(company_db.db_name, company_db.webapi_authcode)
		const cStore = new Anvil.models.rest.Client('ugyfel.c-store.eu', 443, auth)

		const res = await cStore.post('/api/v4/c-order/push_site_opening_hours', {
			db_name: company_db.db_name,
			site_id: storage.site_id,
			store_id: storage.id,
			opening_hours
		})

		if (res.success !== true) {
			throw new Error(res.error)
		}

		Anvil.toast.success('Elmentve', 'Az üzlet nyitvatartási adatainak mentése sikeres')

		return true
	},

	// NTAK Calendar page

	async page_calendar (params) {

		const year = params.year || new Date().getFullYear()

		const [ storage_calendar, company_dbs, sites, storages ] = await Promise.all([
			Anvil.models.c_order.StorageCalendar.fetch(params.db_name, params.storage_id, year),
			Anvil.models.c_order.CompanyDBList.fetch(),
			Anvil.models.c_order.SiteList.fetch(),
			Anvil.models.c_order.StorageList.fetch()
		])

		const search_form = new Anvil.models.Record({
			place_id: `${params.db_name}_${params.storage_id}`,
			year: year,
			view: 'reports'
		})

		const company_db = company_dbs.getByName(params.db_name)
		const storage = storages.getById(company_db.id, params.storage_id)
		const site = sites.getById(company_db.id, storage.site_id)
		const [ places, events ] = await this.preprocess_calendar(company_dbs, sites, storages, storage_calendar)

		await Anvil.renderPage('/c_order/storage/page_calendar', { db_name: params.db_name, storage_id: params.storage_id, storage_calendar, year, sites, storages, company_db, site, storage, search_form, places, events })
	},

	async action_refresh_calendar () {

		const year = Anvil.page.year

		const [ storage_calendar, company_dbs, sites, storages ] = await Promise.all([
			Anvil.models.c_order.StorageNTAKCalendar.fetch(Anvil.page.db_name, Anvil.page.storage_id, year),
			Anvil.models.c_order.CompanyDBList.fetch(),
			Anvil.models.c_order.SiteList.fetch(),
			Anvil.models.c_order.StorageList.fetch()
		])

		const company_db = company_dbs.getByName(Anvil.page.db_name)
		const storage = storages.getById(company_db.id, Anvil.page.storage_id)
		const site = sites.getById(company_db.id, storage.site_id)
		const [ places, events ] = await this.preprocess_calendar(company_dbs, sites, storages, storage_calendar)

		Anvil.page.storage_calendar = storage_calendar
		Anvil.page.sites = sites
		Anvil.page.storages = storages
		Anvil.page.site = site
		Anvil.page.storage = storage
		Anvil.page.places = places
		Anvil.page.events = events

		Anvil.page.calendar.refetchEvents()
	},

	async preprocess_calendar (company_dbs, sites, storages, storage_calendar) {

		const places = []
		for (const storage of storages.data) {
			const company_db = company_dbs.getById(storage.company_db_id)
			if (!company_db) continue
			const site = sites.getById(storage.company_db_id, storage.site_id)
			if (!site) continue

			places.push({
				id: `${company_db.db_name}_${storage.id}`,

				company_db_id: company_db.id,
				company_db_name: company_db.db_name,

				company_id: site.company_id,
				company_name: site.company_name,
				company_tax_number: site.company_tax_number,

				site_id: site.id,
				site_name: site.name,

				storage_id: storage.id,
				storage_name: storage.name,
				storage_regnumber: storage?.ntak_cert?.regnumber || 'nincs tanúsítvány',
			})
		}

		const events = Object.keys(storage_calendar.data.days).map(d => {
			const e = storage_calendar.data.days[d]
			return Object.assign({}, e, {
				day_d: d,
				start: d,
				allday: true,
				display: 'background',
				/*
				color:  e.subject_day.type == 'NORMAL_NAP' ? 'rgb(76, 117, 30)' :
						e.subject_day.type == 'FORGALOM_NELKULI_NAP' ? 'rgb(136, 123, 20)' :
						e.subject_day.type == 'ADOTT_NAPON_ZARVA' ? '#555' :
						(e.subject_day.type == 'NEM_JELENTETT' && e.subject_day.day_reports.unsent > 0) ? 'rgb(136, 123, 20)' :
						(e.subject_day.type == 'NEM_JELENTETT' && e.subject_day.day_reports.unsent == 0) ? 'darkred' : 'black'
				*/
			})
		})

		return [ places, events ]
	},

	async modal_day (params) {

		const date = params.day
		const day = Anvil.page.storage_calendar.data.days[date]

		if (day) {
			await Anvil.modal('/c_order/storage/modal_day', { date, day })
		}
	},

	async action_confirm_closed_day (db_name, api_key, site_id, store_id, day) {

		const auth = Anvil.models.c_store.Util.encodeApiKey(db_name, api_key)
		const cStore = new Anvil.models.rest.Client('ugyfel.c-store.eu', 443, auth)

		const res = await cStore.post('/api/v4/c-order/mark_closed_ntak_day', {
			db_name,
			site_id,
			store_id,
			day
		})

		if (res.success !== true) {
			throw new Error(res.error)
		}

		Anvil.toast.success('Elmentve', 'A jeletés mentése sikeres')

		return true
	}
}